import React from 'react';
import './StreakBanner.css';

const jours = (n) => `${n} jour${n > 1 ? 's' : ''}`;

/**
 * Les deux morceaux de la ligne, lus à la suite : « titre · sous »
 * (`today` : jour local, AAAA-MM-JJ).
 */
export function texteSerie({ courant, record, derniere_activite: derniere }, today) {
  if (!courant) {
    return record
      ? { titre: "Ta série s'est arrêtée", sous: `record : ${jours(record)}` }
      : { titre: 'Lance ta série', sous: 'saisis tes données chaque jour' };
  }
  const titre = courant === 1 ? 'Série lancée' : `${courant} jours d'affilée`;
  if (derniere !== today) return { titre, sous: "saisis aujourd'hui pour continuer" };
  if (courant === 1) return { titre, sous: 'reviens demain pour continuer' };
  return { titre, sous: courant >= record ? "c'est ton record !" : `record : ${jours(record)}` };
}

/**
 * Ligne de série, au-dessus des boutons de saisie de l'accueil.
 *
 * Un jour compte quand la sportive saisit ce jour-là (heure de Paris) ; la série tient
 * jusqu'à minuit le lendemain. Tant que la série n'est pas chargée, rien n'est affiché.
 */
const StreakBanner = ({ streak, today }) => {
  if (!streak) return null;
  const { titre, sous } = texteSerie(streak, today);
  return (
    <div className={`streak-banner${streak.courant ? '' : ' streak-banner--off'}`} role="status">
      {/* SVG plutôt que l'emoji 🔥, dont la couleur dépend du téléphone. */}
      <svg className="streak-banner__icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2c.6 3.6 2.6 5.4 4.4 7.4C18 11.2 19 13 19 15a7 7 0 0 1-14 0c0-2.6 1.2-4.6 2.8-6.2.2 1.6 1 2.6 2.2 3C9.6 8.4 10.2 5 12 2z" />
      </svg>
      <span className="streak-banner__text">
        <span className="streak-banner__title">{titre}</span>
        {' · '}
        <span>{sous}</span>
      </span>
    </div>
  );
};

export default StreakBanner;
